import React, { useContext, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Modal from "react-bootstrap/Modal";

import CharacterLimitIndicator from "../reusable/character_limit_indicator";
import { ProductContext } from "../data/product_context_management";
import useProductUpdateApi from "../data/use_product_update_api";
import SaveSpinnerButton from "./save_spinner_button";
import VisibilityControl from "../../profiles/VisibilityControl";
import productSchema, { descriptionMaxLength } from "../../../yup_schemas/product_schema";

function HeaderForm() {
  const context = useContext(ProductContext);

  const { product, isUpdating, setOpenEditModal, setGeneralError } = context;

  const [descriptionLength, setDescriptionLength] = useState(product.description?.length || 0);
  const { updateProduct } = useProductUpdateApi({ ...context });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(productSchema),
  });

  const handleDescriptionChange = (event) => {
    setDescriptionLength(event.target.value.length);
  };

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const onSubmit = async (data, event) => {
    event.preventDefault();

    const pageConfig = {
      ...product.page_config,
    };

    const submitData = { ...data, page_config: pageConfig };

    updateProduct(submitData);
  };

  return (
    <>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3 row">
            <label htmlFor="name" className="col-sm-3 col-form-label">
              Product Name
            </label>
            <div className="col-sm-9">
              <input id="name" type="text" className="form-control" {...register("name")} defaultValue={product.name} />
              {errors?.name && <span className="text-danger">{errors?.name?.message}</span>}
            </div>
          </div>
          <div className="mb-3 row">
            <label htmlFor="headline_custom" className="col-sm-3 col-form-label">
              Headline
            </label>
            <div className="col-sm-9">
              {/* The API serves headline_custom under the name `headline`: read one, write the other. */}
              <input
                id="headline_custom"
                type="text"
                className="form-control"
                placeholder="Catchy headline to display under the product name."
                {...register("headline_custom")}
                defaultValue={product.headline}
              />
              {errors?.headline_custom && <span className="text-danger">{errors?.headline_custom?.message}</span>}
            </div>
          </div>
          <div className="mb-3 row">
            <label htmlFor="name" className="col-sm-3 col-form-label">
              Product Price
            </label>
            <div className="col-sm-9">
              $&nbsp;
              <input
                id="price"
                type="text"
                className="form-control d-inline-block w-auto"
                {...register("price")}
                defaultValue={product?.price}
              />
              {errors?.price && <span className="d-block text-danger">{errors?.price?.message}</span>}
            </div>
          </div>
          <div className="mb-3 row">
            <span className="col-sm-3 col-form-label">Visibility</span>
            <div className="col-sm-9">
              <Controller
                name="visibility"
                control={control}
                defaultValue={product.visibility}
                render={({ field }) => <VisibilityControl value={field.value} onChange={field.onChange} />}
              />
            </div>
          </div>
          <div className="mb-3 row">
            <label htmlFor="overview" className="col-sm-3 col-form-label">
              Description
            </label>
            <div className="col-sm-9">
              <textarea
                id="description"
                className="form-control"
                rows="6"
                {...register("description")}
                defaultValue={product.description}
                onChange={handleDescriptionChange}
              />
              <div className="mt-2">
                <CharacterLimitIndicator
                  fieldName="description"
                  length={descriptionLength}
                  maxLength={descriptionMaxLength}
                />
                {errors?.description && <span className="text-danger">{errors?.description?.message}</span>}
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <SaveSpinnerButton
          inactiveText="Save"
          activeText="Saving..."
          isSaving={isUpdating}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
        />
        <button type="button" className="btn btn-link" onClick={closeModal}>
          Cancel
        </button>
      </Modal.Footer>
    </>
  );
}

export default HeaderForm;
